const Config = {
  API_URL: process.env.REACT_APP_API_URL,
  AUTH_GOOGLE_CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
  GOOGLE_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
};

export default Config;
